<section
    class="storage-usage mb-6"
    [class.storage-usage--critical]="storageStatus() === StorageStatusEnum.CRITICAL"
    [class.storage-usage--warning]="storageStatus() === StorageStatusEnum.WARNING">
    <h3 class="mb-3 text-sm font-medium">{{ 'storage.storage' | transloco }}</h3>

    <div class="mb-1 flex items-center justify-between gap-3">
        <div class="flex items-center gap-2">
            <small class="font-semibold">
                {{ usagePercentage() / 100 | percent: '1.0-0' }}
            </small>

            @if (storageStatus() !== StorageStatusEnum.NORMAL) {
                <span class="storage-usage__badge">
                    <fa-icon
                        aria-hidden="true"
                        [icon]="['fas', 'triangle-exclamation']" />
                    {{ storageMessageKey() | transloco }}
                </span>
            }
        </div>
        <span class="shrink-0 text-on-surface">
            {{ storage().usedStorage | number: '1.0-1' }} / {{ storage().maxStorage }} {{ 'storage.unit' | transloco }}
        </span>
    </div>

    <div
        aria-valuemax="100"
        aria-valuemin="0"
        class="storage-usage__progress"
        role="progressbar"
        [attr.aria-valuenow]="usagePercentage()">
        <div
            class="storage-usage__progress-fill"
            [style.width.%]="usagePercentage()"></div>
    </div>
</section>
